/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './user-menu.scss';

/* eslint-disable import/no-unresolved, import/default */

import userMenuTemplate from './user-menu.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.usermenu', [])
    .directive('tkUserMenu', UserMenu)
    .name;

/*@ngInject*/
function UserMenu() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            displayUserInfo: '=',
        },
        controller: UserMenuController,
        controllerAs: 'vm',
        templateUrl: userMenuTemplate
    };
}

/*@ngInject*/
function UserMenuController($scope, userService, $translate, $state, types) {

    var vm = this;
    var currentUser;

    vm.$onInit = function () {
        currentUser = userService.getCurrentUser();

        vm.authorityName = authorityName;
        vm.logout = logout;
        vm.openProfile = openProfile;
        vm.userDisplayName = userDisplayName;
        vm.isProvider = isProvider;
        vm.openProviderDetails = openProviderDetails;
        vm.isCustomer = isCustomer;
        vm.openCustomerDetails = openCustomerDetails;
    };

    function authorityName() {
        var name = "user.anonymous";
        if (currentUser) {
            var authority = currentUser.authority;
            name = types.authority[authority].name;
        }
        return $translate.instant(name);
    }

    function isProvider() {
        if (currentUser) {
            var authority = currentUser.authority;
            return types.authority[authority].scope == types.scope.provider;
        } else {
            return false;
        }
    }

    function isCustomer() {
        if (currentUser) {
            var authority = currentUser.authority;
            return types.authority[authority].scope == types.scope.customer;
        } else {
            return false;
        }
    }

    function userDisplayName() {
        var name = "";
        if (currentUser) {
            if ((currentUser.firstName && currentUser.firstName.length > 0) ||
                (currentUser.lastName && currentUser.lastName.length > 0)) {
                if (currentUser.firstName) {
                    name += currentUser.firstName;
                }
                if (currentUser.lastName) {
                    if (name.length > 0) {
                        name += " ";
                    }
                    name += currentUser.lastName;
                }
            } else {
                name = currentUser.email;
            }
        }
        return name;
    }

    function openProfile() {
        $state.go('home.profile');
    }

    function openProviderDetails() {
        $state.go('home.provider');
    }

    function openCustomerDetails() {
        $state.go('home.customer');
    }

    function logout() {
        userService.logout();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/user-menu.directive.js